// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatContextMenu_root__EEP0M {
  border-radius: 12px !important;
  -webkit-user-select: none;
          user-select: none;
}

.ChatContextMenu_paper__WwF7D {
  box-shadow: 0px 187px 75px rgba(0, 0, 0, 0.01), 0px 105px 63px rgba(0, 0, 0, 0.05), 0px 47px 47px rgba(0, 0, 0, 0.09), 0px 12px 26px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1) !important;
  border-radius: 12px !important;
}

.ChatContextMenu_danger__5lF9O {
  color: #E23834;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/ChatContextMenu/ChatContextMenu.module.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,yBAAA;UAAA,iBAAA;AACF;;AAEA;EACE,kMAAA;EACA,8BAAA;AACF;;AAEA;EACE,cAAA;AACF","sourcesContent":[".root {\n  border-radius: 12px !important;\n  user-select: none;\n}\n\n.paper {\n  box-shadow: 0px 187px 75px rgba(0, 0, 0, 0.01), 0px 105px 63px rgba(0, 0, 0, 0.05), 0px 47px 47px rgba(0, 0, 0, 0.09), 0px 12px 26px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1) !important;\n  border-radius: 12px !important;\n}\n\n.danger {\n  color: #E23834;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ChatContextMenu_root__EEP0M`,
	"paper": `ChatContextMenu_paper__WwF7D`,
	"danger": `ChatContextMenu_danger__5lF9O`
};
export default ___CSS_LOADER_EXPORT___;
